import { classnames } from '@tailwindcss-classnames';

export const cardContentWrapper = classnames('flex', 'flex-col', 'w-full');
export default cardContentWrapper;
